import dayjs from "dayjs";

const getEmploymentStatus = (employment_status: string): string => {
  const employmentStatuses = [
    {
      status: 'employed',
      code: '1'
    },
    {
      status: 'student',
      code: '2'
    },
    {
      status: 'retired',
      code: '3'
    },
    {
      status: 'other',
      code: '4'
    }
  ];
  const status = employmentStatuses.find(
    (status) => status.status === employment_status
  );

  return status?.code || '4';
};

const employmentIncomePeriods = {
  annual: '1',
  monthly: '2',
  weekly: '3'
};

export const getScreeningRequestData = async (
  appGroupData: any,
  unitRent: any,
  plaidResults: any,
  // applicationNumber?: string,
) => {
  try {
    const { application_group, applicants, desired_lease_term, desired_unit_number, tu_property_id } = appGroupData;
    const { applicantsIncome, applicantsBankIncome } = plaidResults.data;

    const Applicants = applicants.map((applicant: any, index: number) => {
      const payrollIncome = applicantsIncome?.[index]?.monthlyIncome ?? 0;
      const bankIncome = applicantsBankIncome?.[index]?.included_income ?? 0;
      const manualIncome = applicant.manual_income ?? 0;
      // Plaid income (payroll takes priority over bank) + Manual/Supplemental income
      const plaidIncome = payrollIncome || bankIncome;
      const monthlyIncome = (plaidIncome + manualIncome) || 1; // Add Plaid + Manual, fallback to 1 if both are 0
      const employment_status = getEmploymentStatus(applicant.employment_status)

      const applicantData: any = {
        SourceRef: applicant.application_id,
        ApplicantType: "1",
        FirstName: applicant.first_name,
        MiddleName: applicant.middle_name,
        LastName: applicant.last_name,
        DateOfBirth: dayjs(applicant.dob).format("YYYY-MM-DD"),
        StreetAddress: applicant.current_residence_address,
        City: applicant.current_residence_city,
        State: applicant.current_residence_state,
        PostalCode: applicant.current_residence_zip,
        Email: applicant.email,
        Phone: applicant.phone_number,
        Ssn: applicant.social_security_number,
        EmploymentIncomePeriod: employmentIncomePeriods.monthly,
        EmploymentIncome: monthlyIncome.toString(),
        EmploymentStatus: employment_status,
        // ...(applicationNumber && {
        //   ScreeningType: {
        //     Credit: "true"
        //   }
        // }) 
      };

      return applicantData;
    });

    const screeningRequestData = {
      PropertyId: tu_property_id,
      SourceRef: application_group,
      RentAmount: unitRent.data != null ? unitRent.data.toString() : "",
      DepositAmount: unitRent.data != null ? unitRent.data.toString() : "",
      LeaseTerm: desired_lease_term,
      Unit: desired_unit_number,
      Applicants
    };

    return screeningRequestData;
  } catch (error) {
    return null;
  }
};
